<template>
  <div class="grade">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="证书证章" name="first">
        <div class="grade_title">
          <h2>
            {{ userRole == 1 ? "运动员" : userRole == 2 ? "考评员" : "" }}
          </h2>
          <el-button
            class="grade_title_but"
            type="danger"
            @click="apply"
            :disabled="!zzZs.length > 0"
            >申请证书证章</el-button
          >
        </div>
        <div class="grade_content">
          <div class="grade_content_zz">
            <span class="wz">证章</span>
            <div class="demo-image__preview" v-if="userRole == 1">
              <el-image
                class="img"
                :src="childImgUrl"
                :preview-src-list="zzList"
                v-if="childImgUrl"
              ></el-image>
              <el-image
                class="img"
                :src="adultImageUrl"
                :preview-src-list="zzList"
                v-else-if="adultImageUrl"
              ></el-image>
              <no-data v-else />
            </div>
            <div class="demo-image__preview" v-if="userRole == 2">
              <template v-if="zzZs.length > 0">
                <el-image
                  class="img"
                  :src="'/image/personal/' + item.certificate_grade + '.png'"
                  v-for="(item, index) in zzZs"
                  :key="index"
                  :preview-src-list="zzList"
                  @click="zzClick"
                ></el-image>
              </template>
              <no-data v-else />
            </div>
          </div>
          <div class="grade_content_zs">
            <span class="wz">证书</span>
            <div class="demo-image__preview">
              <template v-if="zzZs.length > 0">
                <el-image
                  class="img"
                  :src="imgPath + item.certificate_url"
                  :preview-src-list="zsList"
                  v-for="(item, index) in zzZs"
                  :key="index"
                  @click="zsClick(item, index)"
                ></el-image>
              </template>
              <no-data v-else />
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="申请记录" name="second">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column label="订单号" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.payment_order_sn }}</span>
            </template>
          </el-table-column>
          <el-table-column label="申请日期" align="center" width="100px">
            <template slot-scope="scope">
              <span>{{
                scope.row.creationTime | dateformat("YYYY-MM-DD")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="证书等级" align="center" width="150px">
            <template slot-scope="scope">
              <p v-for="(item, index) in scope.row.record_list" :key="index">
                {{ item.certificate_grade }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="类型" align="center" width="150px">
            <template slot-scope="scope">
              <p v-for="(item, index) in scope.row.record_list" :key="index">
                {{ item.certificate_type | type }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="费用" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.amount">{{ scope.row.amount + "元" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="快递公司" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.express_company }}</span>
            </template>
          </el-table-column>
          <el-table-column label="快递单号" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.express_number }}</span>
            </template>
          </el-table-column>
          <el-table-column label="寄出时间" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.mailing_time">{{
                scope.row.mailing_time | dateformat("YYYY-MM-DD")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.payment_status }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button
                @click="application(scope.row)"
                type="text"
                size="small"
                v-if="scope.row.payment_status == '待支付'"
                >付款</el-button
              >
              <el-button
                @click="view(scope.row)"
                type="text"
                size="small"
                v-if="scope.row.payment_status == '支付成功'"
                >查看物流</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination" style="margin-top: 55px; text-align: center">
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size="paging.limit"
            :total="totalCount"
            v-if="totalCount > 10"
          ></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="机构代领" name="three" v-if="userRole == 1">
        <el-table :data="tableData1" style="width: 100%">
          <el-table-column label="序号" width="70px" align="center">
            <template slot-scope="scope">
              <span>{{
                (paging1.page - 1) * paging1.limit + scope.$index + 1
              }}</span>
            </template>
          </el-table-column>

          <el-table-column label="申请时间" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.lastModificationTime">{{
                scope.row.lastModificationTime | dateformat("YYYY-MM-DD")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="测试机构全称" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.mechanism_fullName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="班级名称" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.classTitle }}</span>
            </template>
          </el-table-column>
          <el-table-column label="证书等级" align="center">
            <template slot-scope="scope">
              <p>{{ scope.row.grade | grade }}</p>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination" style="margin-top: 55px; text-align: center">
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="handleCurrentChange1"
            :page-size="paging1.limit"
            :total="totalCount1"
            v-if="totalCount1 > 10"
          ></el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      title="证书证章领取方式"
      :visible.sync="centerDialogVisible"
      :width="screenWidth > 768 ? '40%' : '90%'"
      center
    >
      <!-- <h3 class="tishih3">您已通过{{level|grade}}等级测试，请选择证书证章领取方式</h3> -->
      <div style="text-align: center; margin-bottom: 20px">
        <!-- <el-radio v-model="radio" label="1" border style="margin:10px">机构代领</el-radio> -->
        <el-radio v-model="radio" label="2" border style="margin: 10px"
          >自行领取</el-radio
        >
      </div>
      <div v-if="radio == 1" style="padding: 10px">
        <p style="margin: 0px 0px 10px 0px">请选择需要代领等级的证书证章：</p>
        <el-checkbox-group v-model="gradeIdList">
          <el-checkbox
            :label="item.id"
            v-for="item in gradeList"
            :key="item.id"
            style="margin: 10px 20px 10px 20px"
            >{{ item.certificate_grade | grade }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sure" :loading="loading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="二维码支付"
      :visible.sync="paydialog"
      :width="screenWidth > 768 ? '40%' : '90%'"
      center
      :close-on-click-modal="false"
    >
      <div class="paystyle">
        <img v-if="this.formData.img" :src="this.formData.img" />
        <div>仅支持微信扫码支付</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetPersonalCertificate,
  GetCertificateRecordList,
  GetApplicationWay,
  ApplicationWayList,
} from "@/api/admin/appraiser.js";
import {
  GetDicData,
  GDCloudPayV1,
  GetPaymentStatus,
} from "@/api/admin/common.js";
import { mapGetters } from "vuex";
import noData from "@/views/admin/components/noData.vue";
import { getStore } from "@/util/store";

//声明一个全局变量
let that;
export default {
  computed: {
    ...mapGetters(["userRole", "screenWidth", "personalInfo"]),
  },
  components: {
    noData,
  },
  data() {
    return {
      //imgPath: window.apiObj.apiUrl,
      formData: {},
      payview: false,
      paydialog: false,
      paytime: null,
      sn: null,
      activeName: "first",
      tableData: [],
      tableData1: [],
      paging: {
        limit: 10,
        page: 1,
      },
      paging1: {
        limit: 10,
        page: 1,
      },
      totalCount: 0,
      totalCount1: 0,
      certificate_grade: [],
      certificate_type: [],
      zzList: [],
      zsList: [],
      zzZs: [],
      radio: "2",
      centerDialogVisible: false,
      childImgUrl: "",
      adultImageUrl: "",
      adult: [
        {
          grade: "4",
          base: 1,
        },
        {
          grade: "5",
          base: 2,
        },
        {
          grade: "6",
          base: 4,
        },
        {
          grade: "7",
          base: 8,
        },
        {
          grade: "8",
          base: 16,
        },
        {
          grade: "9",
          base: 32,
        },
      ],
      child: [
        {
          grade: "10",
          base: 1,
        },
        {
          grade: "11",
          base: 2,
        },
        {
          grade: "12",
          base: 4,
        },
        {
          grade: "13",
          base: 8,
        },
        {
          grade: "14",
          base: 16,
        },
        {
          grade: "15",
          base: 32,
        },
        {
          grade: "16",
          base: 64,
        },
      ],
      adult_: "",
      child_: "",
      value1: 0,
      value2: 0,
      newCertificate: "",
      loading: false,
      imgPath: window.apiObj.apiUrl,
      respXml: "",
      gradeList: [],
      gradeIdList: [],
      userNumber: {},
    };
  },
  beforeDestroy() {
    clearTimeout(this.paytime);
  },
  created() {
    this.getList();
    this.getList1();
    this.dicData();
    this.intervalPay();
    this.paytime = setInterval(() => {
      this.intervalPay();
    }, 10000);
    if (this.userRole == 1) {
      this.mechanism();
    }
    if (getStore({ name: "activeName" })) {
      this.activeName = getStore({ name: "activeName" });
    }
    if (
      this.$route.query.statusPay == 1 ||
      this.$route.query.statusPay == "1"
    ) {
      this.activeName = "second";
      this.$store.commit("SER_ACTIVENAME", this.activeName);
    }
  },
  beforeCreate: function () {
    that = this;
  },
  methods: {
    intervalPay() {
      if (this.payview) {
        if (this.sn != null) {
          GetPaymentStatus({ order_sn: this.sn }).then((data) => {
            if (data.data.result.orderStatus == 3) {
              this.$message({
                message: "支付完成",
                type: "success",
              });
              this.paydialog = false;
              this.payview = false;
              this.sn = null;
              this.getList();
            }
          });
        }
      }
    },

    getList() {
      GetCertificateRecordList(Object.assign(this.paging)).then((data) => {
        var list = data.data.result;

        if (list) {
          this.tableData = list.items;
          this.totalCount = list.totalCount;
        }
      });
    },
    getList1() {
      ApplicationWayList(
        Object.assign({ userType: this.userRole }, this.paging1)
      ).then((data) => {
        var list = data.data.result;
        if (list) {
          this.tableData1 = list.items;
          this.totalCount1 = list.totalCount;
        }
      });
    },
    dicData() {
      this.userNumber.userNumber = this.personalInfo.userid;
      this.gradeIdList = [];
      this.zsList = [];
      this.zzList = [];
      this.value1 = 0;
      this.value2 = 0;
      GetPersonalCertificate(Object.assign(this.userNumber)).then((data) => {
        let list = data.data.result;
        if (list.items.length > 0) {
          this.gradeIdList.push(list.items[0].id);
          this.newCertificate = list.items;
          this.zzZs = list.items;
          this.zzZs.forEach((i) => {
            this.zsList.push(this.imgPath + i.certificate_url);
          });
          // 证章处理
          if (this.userRole == 1) {
            // 运动员 ----少儿，成人
            this.zzZs.forEach((i) => {
              if (
                this.adult.some((record) => {
                  return record.grade == i.certificate_grade;
                })
              ) {
                this.adult_ = "adult_";
                this.adult.forEach((j) => {
                  if (j.grade == i.certificate_grade) {
                    this.value1 += j.base;
                  }
                });
              } else if (
                this.child.some((record) => {
                  return record.grade == i.certificate_grade;
                })
              ) {
                this.child_ = "child_";
                this.child.forEach((j) => {
                  if (j.grade == i.certificate_grade) {
                    this.value2 += j.base;
                  }
                });
              }
            });
            if (this.value1) {
              this.adultImageUrl =
                "/image/output/" + this.adult_ + this.value1 + ".png";
              this.zzList.push(this.adultImageUrl);
            }
            if (this.value2) {
              this.childImgUrl =
                "/image/output/" + this.child_ + this.value2 + ".png";
              this.zzList.push(this.childImgUrl);
            }
          } else if (this.userRole == 2) {
            // 考评员
            this.zzZs.forEach((i) => {
              this.certificate_grade.forEach((j) => {
                if (j.value == i.certificate_grade) {
                  var Kimgs = "/image/personal/" + i.certificate_grade + ".png";
                  this.zzList.push(Kimgs);
                }
              });
            });
          }
        }
      });
      GetDicData({ classCode: "certificate_grade" }).then((data) => {
        if (data.data.result) {
          this.certificate_grade = data.data.result;
        }
      });
    },
    mechanism() {},
    handleClick(tab, event) {
      this.$store.commit("SER_ACTIVENAME", this.activeName);
    },
    application(row) {
      this.sn = row.payment_order_sn;
      GDCloudPayV1({ order_sn: this.sn }).then((data) => {
        if (data.data.result.isSuccess) {
          this.paydialog = true;
          this.payview = true;

          //this.formData.img = "http://218.58.55.130:8765"+data.data.result.payCode;
          this.formData.img = this.imgPath + data.data.result.payCode;
        }
        // this.payview=true;
        // this.paydialog = true;
      });
    },
    view(row) {
      this.$router.push({
        path: "/personal/gradeCertificateDelivery/logistics",
        query: { id: row.express_number },
      });
    },
    handleCurrentChange(page) {
      this.paging.page = page;
      this.getList();
    },
    handleCurrentChange1(page) {
      this.paging1.page = page;
      this.getList1();
    },
    apply() {
      if (this.userRole == 1) {
        this.gradeList = [];
        this.gradeIdList = [];
        var nowdate = new Date(new Date().setDate(new Date().getDate() - 7));
        this.newCertificate.forEach((j) => {
          if (
            !(nowdate > new Date(j.created_date)) &&
            !j.is_grant &&
            !j.isEvent
          ) {
            this.gradeList.push(j);
            this.gradeIdList.push(j.id);
          }
        });
        var timeJudgement = this.newCertificate.some((i) => {
          // false 七天内  is_grant:false 授权  isEvent :true 赛事申请证书
          return (
            !(nowdate > new Date(i.created_date)) && !i.is_grant && !i.isEvent
          );
        });

        if (!timeJudgement) {
          this.centerDialogVisible = false;
          this.$router.push({ path: "/personal/gradeCertificateDelivery" });
        } else {
          this.centerDialogVisible = true;
        }
      } else if (this.userRole == 2) {
        this.centerDialogVisible = false;
        this.$router.push({ path: "/personal/gradeCertificateDelivery" });
      }
    },
    sure() {
      if (this.radio == "1") {
        var list = this.gradeIdList;
        if (list.length > 0) {
          GetApplicationWay({ ApplicationWay: 1, id: list })
            .then((data) => {
              if (data.data.result.isSuccess) {
                this.$message({
                  message: "机构代领申请成功",
                  type: "success",
                });
                this.dicData();
                this.getList1();
                this.centerDialogVisible = false;
                // this.$forceUpdate();
              }
            })
            .catch(() => {
              this.centerDialogVisible = false;
            });
        } else {
          this.$message({
            message: "请至少选择一个等级",
            type: "warning",
          });
        }
      } else if (this.radio == "2") {
        this.$router.push({ path: "/personal/gradeCertificateDelivery" });
      }
    },
    zzClick() {},
    zsClick() {},
  },
  filters: {
    grade: (data) => {
      for (var i in that.certificate_grade) {
        if (that.certificate_grade[i].value == data) {
          return that.certificate_grade[i].label;
        }
      }
    },
    type: (data) => {
      switch (data) {
        case 0:
          return "证书";
        case 1:
          return "证章";
        case 2:
          return "证书和证章";
      }
    },
    status: (data) => {
      switch (data) {
        case 0:
          return "未发货";
        case 1:
          return "已发货";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.grade {
  .grade_title {
    position: relative;
    text-align: center;
    h2 {
      margin-bottom: 15px;
    }
    @media screen and (min-width: 768px) {
      .grade_title_but {
        position: absolute;
        right: 0px;
        top: 0px;
      }
    }
  }
  .grade_content {
    .grade_content_zz {
      text-align: center;
      padding-bottom: 15px;
      .img {
        height: 20vw;
        width: 20vw;
        padding: 10px;
      }
    }
    .grade_content_zs {
      border-top: 2px solid #eee;
      text-align: center;
      padding-top: 15px;
      .img {
        height: 30vw;
        width: 20vw;
        padding: 10px;
      }
    }
    .wz {
      display: block;
      text-align: left;
    }
  }
  .tishih3 {
    padding: 0px 0px 15px 0px;
    text-align: center;
  }
}
.paystyle {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  color: #ea0000;
}
</style>
